import React, { useState, useEffect } from 'react';
import './Manage.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Invoice from './Invoice'; // Adjust path if necessary
import axios, { decryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';

const Container = ({ batchDetails }) => {
  const [openModal, setOpenModal] = useState(false);
  const [intakedata, setIntakedata] = useState([]);
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [scheduleDetailsWithModules, setScheduleDetailsWithModules] = useState([]);
  const { intakeId } = useParams();
  const intakeId1 = decryptData(decodeURIComponent(intakeId));


  //   useEffect(() => {
  //     if (intakedata?.moduleDetails && intakedata?.scheduleDateDetails) {
  //         // Create a map of module IDs to module names
  //         const moduleDetailsMap = intakedata.moduleDetails.reduce((map, module) => {
  //             map[module.id] = module.moduleName;
  //             return map;
  //         }, {});

  //         // Calculate total modules
  //         const totalModules = Object.keys(moduleDetailsMap || {}).length;

  //         // Function to retrieve module name with cyclic ID adjustment
  //         const getModuleName = (startModulus) => {
  //             const adjustedId = ((startModulus - 1 + totalModules) % totalModules) + 1;
  //             return moduleDetailsMap[adjustedId] || `Unknown Module (ID: ${adjustedId})`;
  //         };

  //         // Map over scheduleDateDetails to add module names
  //         const updatedScheduleDetails = intakedata.scheduleDateDetails.map((schedule) => ({
  //             ...schedule,
  //             moduleName: getModuleName(schedule.startModulus),
  //         }));

  //         // Store the updated schedule details in state
  //         setScheduleDetailsWithModules(updatedScheduleDetails);
  //     }
  // }, [intakedata]);

  // console.log("Schedule Details With Modules", scheduleDetailsWithModules);

  // function getCurrentModule(modules) {
  //   const today = new Date(); // Get the current date

  //   // Check if there are no modules
  //   if (modules.length === 0) return "No module is currently active";

  //   // Find the first and last module based on dates
  //   const firstModule = modules[0];
  //   const lastModule = modules[modules.length - 1];

  //   const startDateFirst = new Date(firstModule.startDate);
  //   const endDateLast = new Date(lastModule.endDate);

  //   // If today is before the start date of the first module
  //   if (today < startDateFirst) {
  //       return firstModule.moduleName; // Return the first module name
  //   }

  //   // If today is after the end date of the last module
  //   if (today > endDateLast) {
  //       return lastModule.moduleName; // Return the last module name
  //   }

  //   // Find the module where today's date falls between startDate and endDate
  //   const currentModule = modules.find(module => {
  //       const startDate = new Date(module.startDate);
  //       const endDate = new Date(module.endDate);
  //       return today >= startDate && today <= endDate;
  //   });

  //   return currentModule ? currentModule.moduleName : "No module is currently active";
  // };

  console.log("ll",batchDetails)

  


  useEffect(() => {
    console.log("batchDetails",batchDetails)
    const fetchBatches = async () => {
      try {
        const response = await axios.get("batch-summary"); // API endpoint to get batches
        const filteredBatches = response.data.filter(
          (batch) => batch.id === batchDetails.batchId
        );

        setBatches(filteredBatches[0]);
        console.log("hh",filteredBatches[0])
        // setBatches(response.data);
      } catch (error) {
        console.error("Error fetching batches:", error);
      }
    };

    fetchBatches();
  }, []);

  const moduleDetailsMap = {};
  batches?.moduleDetails?.forEach((module) => {
    moduleDetailsMap[module.id] = module.moduleName;
    
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/intake-details/intake/${intakeId1}`);
        if (response.data) {
          setIntakedata(response.data);
          setLoading(false);
        } else {
          throw new Error('Data format is incorrect');
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [intakeId1]);

  if (loading) {
    return <Typography variant="body1">Loading...</Typography>;
  }

  if (!batchDetails) {
    return <Typography variant="body1">No batch details available.</Typography>;
  }



  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const intakeDays = intakedata.intakeDetailsDays || [];

  return (
    <div className="container-fluid" style={{ maxWidth: '1250px', marginTop: '20px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      <Grid container spacing={3}>
        {/* <Grid item xs={12}>
          <Typography variant="h6" style={{ marginBottom: '10px' }}>
            Batch Details
          </Typography>
        </Grid> */}

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <strong>Course:</strong> {intakedata.course}
          </Typography>
          <Typography variant="body1" style={{ marginTop: '10px' }}>
            <strong>Venue:</strong> Online/Classroom
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <strong>Day:</strong>
            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
              {intakeDays.length > 0 && intakeDays.map((intakeDay, index) => (
                <span key={index}>
                  {intakeDay.day}
                  {index < intakeDays.length - 1 && ', '}
                </span>
              ))}
            </span>
            {/* <Button
              variant="outlined"
              style={{ marginLeft: '10px', textTransform: 'capitalize', borderRadius: '4px', borderColor: '#007bff', color: '#007bff' }}
              onClick={handleOpenModal}
            >
              Change
            </Button> */}
          </Typography>

          <Typography variant="body1" style={{ marginTop: '10px' }}>
            {/* <strong>Start Module:</strong> {getModuleName(item.startModulus)} */}
            <strong>Current Modulename:</strong> {moduleDetailsMap[batches.currentModule]}
            {/* <strong>Current Modulename:</strong> {getCurrentModule(scheduleDetailsWithModules)} */}
          </Typography>
        </Grid>
      </Grid>



      {/* Dialog with Header, Body, and Footer */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ style: { padding: '20px', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' } }}
      >
        {/* Dialog Header */}
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" component="div">Change Session Details</Typography>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Dialog Body */}
        <DialogContent dividers>
          <Invoice />
        </DialogContent>

        {/* Dialog Footer */}
        <DialogActions>
          <Button onClick={handleCloseModal} variant="outlined" style={{ borderRadius: '4px', borderColor: '#007bff', color: '#007bff' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Container;
